/**
 * Собирает URL к списку сделок (`DealsList`, id таблицы `crm-deals`) с
 * предустановленными фильтрами.
 *
 * Централизует связку со схемой URL-параметров RepositoryTable
 * (`${tableId}_f_${key}`), чтобы имена ключей и id таблицы не расползались по
 * блокам WelcomePage. При переименовании id таблицы или ключей фильтров —
 * правится только здесь.
 *
 * Соответствие ключей — см. `DealsList.tsx` (id='crm-deals') и её фильтры:
 * - status  → FilterByStatus.filterByStatuses (JSON-массив id)
 * - onlyMine → FilterByOnlyMine ('mine' | 'all')
 * - branch  → FilterByBranch.filterByOwnerGroups (id группы-филиала)
 */
const DEALS_TABLE_ID = 'crm-deals';

interface DealsListFilters {
  /** Id статуса сделки — раскрывается в фильтр по статусу (одиночный). */
  statusId?: number;
  /** Только мои сделки (owner = текущий пользователь). */
  mine?: boolean;
  /** Id группы-филиала — фильтр по филиалу ответственного. */
  branchId?: number;
}

export function buildDealsListUrl(filters: DealsListFilters): string {
  const params = new URLSearchParams();
  const key = (name: string) => `${DEALS_TABLE_ID}_f_${name}`;

  if (filters.statusId !== undefined) {
    params.set(key('status'), JSON.stringify([filters.statusId]));
  }
  // onlyMine проставляем ЯВНО всегда: у фильтра defaultValue 'mine', поэтому
  // без параметра список открылся бы в режиме «Мои» и скрыл данные, которые мы
  // хотим показать по переданным фильтрам (напр. по филиалу).
  params.set(key('onlyMine'), filters.mine ? 'mine' : 'all');
  if (filters.branchId !== undefined) {
    params.set(key('branch'), String(filters.branchId));
  }

  const query = params.toString();
  return query ? `/crm/deals?${query}` : '/crm/deals';
}
